module.exports = __webpack_public_path__ + "img/icon-guide.8ccf3dee.svg";